module.exports = __webpack_public_path__ + "img/Size=64, Style=regular.ba87caa4.svg";